module.exports = __webpack_public_path__ + "public/media/marketeer-vector2.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer-vector2.png
// module id = ./images/services/marketeer-vector2.png
// module chunks = 0